/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListAvailTicketsRequest as AgentApiContractListAvailTicketsRequest } from '../../models/AgentApi/Contract/list-avail-tickets-request';
import { ListAvailTicketsResponse as AgentApiContractListAvailTicketsResponse } from '../../models/AgentApi/Contract/list-avail-tickets-response';

export interface ApiAgentListAvailTicketsPost$Plain$Params {

/**
 * ui language code.
 */
  lang?: string;
      body?: AgentApiContractListAvailTicketsRequest
}

export function apiAgentListAvailTicketsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentListAvailTicketsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListAvailTicketsResponse>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListAvailTicketsPost$Plain.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractListAvailTicketsResponse>>;
    })
  );
}

apiAgentListAvailTicketsPost$Plain.PATH = '/api/Agent/ListAvailTickets';
